var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"double-button-floating-frame",class:{
    'has-bottom-margin-for-mobile-nav-bar': _vm.hasBottomMarginForMobileNavBar,
  }},[_c('div',{staticClass:"double-button-floating-frame__button"},[_vm._t("left-button")],2),_vm._v(" "),_c('div',{staticClass:"double-button-floating-frame__button"},[_vm._t("right-button")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }